"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const clsx_1 = __importDefault(require("clsx"));
const ConfirmationPopup = (props) => {
    const { onCancel, onConfirm, title, children, cancelButtonText, confirmButtonText, confirmButtonClassName, disabled, cancelButtonIcon, } = props;
    return (react_1.default.createElement("div", { className: "confirmation-popup" },
        title && react_1.default.createElement("h3", null, title),
        children,
        react_1.default.createElement("div", { className: "buttons" },
            cancelButtonText && onCancel && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onCancel, icon: cancelButtonIcon, iconAltText: (0, clsx_1.default)(cancelButtonIcon && cancelButtonText) }, cancelButtonText)),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: onConfirm, className: confirmButtonClassName, disabled: !!disabled }, confirmButtonText))));
};
exports.default = ConfirmationPopup;
